import React, { useEffect } from "react";
import TransferenciasCuentasIfisHeader from "./TransferenciasCuentasIfisHeader";
import {
  Container,
  Header,
  Form,
  Button,
  Grid,
  Icon,
  Label,
} from "semantic-ui-react";
import { useState } from "react";
import {
  FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_INICIAL,
  FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_VALIDACION,
  FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_PROCESADO,
  LONGITUD_MAXIMA_IMPORTE,
  RESPONSE_MESSAGE_CODE_SUCCESS,
  LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR,
  LONGITUD_MINIMA_CCI,
  LONGITUD_MAXIMA_CCI,
  LONGITUD_MAXIMA_APELLIDOS_NOMBRES_DESTINATARIO,
  INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_TRUE,
  INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_FALSE,
  CODIGO_BANCO_BCP,
  CODIGO_BANCO_SCOTIABANK,
  LABEL_CONFIRMAR_OPERACION_CLAVE_DOBLE_FACTOR,
  CODIGO_TIPO_PROCESO_AUDITORIA_TRANSFERENCIAS_OTROS_BANCOS,
  MESSAGE_VALIDACION_CLAVE_DOBLE_FACTOR,
  LABEL_INGRESE_CLAVE_DOBLE_FACTOR,
} from "../../../../app/infrastructure/appConstants";
import SelectedInput from "../../../../app/common/form/SelectedInput";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { getCuentasOperaciones } from "../../../../app/store/actions/cuentaActions";
import {
  generarClaveDobleFactor,
  validarClaveDobleFactor,
} from "../../../../app/store/actions/transactionalActions";
import { verificarDisponibilidadPago } from "../../../../app/store/actions/pagoActions";
import {
  transferenciaCuentasIfisValidar,
  transferenciaCuentasIfisConfirmar,
  listarBancosTransferencia,
} from "../../../../app/store/actions/transferenciaActions";
import {
  createOptionsCuentaTransferencias,
  createOptionsBancosTransferencias,
  createOptionsTipoCuentasPorBancoTransferencia,
} from "../../../../app/util/optionsUtils";
import { connect } from "react-redux";
import { Form as FinalForm, Field } from "react-final-form";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthBetween,
  hasLengthLessThan,
  isRequiredIf,
} from "revalidate";
import {
  isCuentaDestinoDiferente,
  isGreaterThanOrEqual,
  isCodigoCuentaInterbancarioValido,
} from "../../../../app/util/revalidateUtils";
import { tipoMonedaOptions } from "../../../../app/config/data/options";
import NumberInput from "../../../../app/common/form/NumberInput";
import PropTypes from "prop-types";
import TransferenciasCuentasIfisResumen from "./TransferenciasCuentasIfisResumen";
import { Link } from "react-router-dom";
import TextInput from "../../../../app/common/form/TextInput";
import {
  normalizeNumero,
  normalizeNumeroDocumentoIdentidad,
  getLengthNumeroDocumentoIdentidad,
  normalizeLetrasEspacios,
} from "../../../../app/util/finalFormUtils";
import { toast } from "react-toastify";
import RadioInput from "../../../../app/common/form/RadioInput";
import { tipoDocumentoOptions } from "../../../../app/config/data/options";
import {
  TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL,
  MESSAGE_NUMERO_CUENTA_BANCOS_IFIS,
  MESSAGE_TRANSFERENCIA_CUENTA_ORIGEN,
  MESSAGE_CLAVE_DOBLE_FACTOR_NO_VALIDA,
} from "../../../../app/util/messageUtils";
import DisponibilidadOperacionesMessage from "../../../../app/common/messages/DisponibilidadOperacionesMessage";
import { resetScroll } from "../../../../app/util/JsUtils";
import ModalClaveDobleFactor from "../../../../app/common/modals/ModalClaveDobleFactor";
import {
  buildGenerarClaveDobleFactorRequest,
  buildValidarClaveDobleFactorRequest,
} from "../../../../app/util/transactionalUtils";

const actions = {
  getCuentasOperaciones,
  verificarDisponibilidadPago,
  transferenciaCuentasIfisValidar,
  transferenciaCuentasIfisConfirmar,
  generarClaveDobleFactor,
  validarClaveDobleFactor,
  listarBancosTransferencia,
};
const mapState = (state) => ({
  cuentasOperaciones: state.cuentaReducer.cuentasOperaciones,
  loadingCuentasOperaciones: state.cuentaReducer.loadingCuentasOperaciones,
  currentUser: state.auth.currentUser,
  loadingDisponibilidadPago: state.pagoReducer.loadingDisponibilidadPago,
  loadingTransferenciaCuentasIfisValidar:
    state.transferenciaReducer.loadingTransferenciaCuentasIfisValidar,
  loadingTransferenciaCuentasIfisConfirmar:
    state.transferenciaReducer.loadingTransferenciaCuentasIfisConfirmar,
  loadingGenerarClaveDobleFactor:
    state.transactionalReducer.loadingGenerarClaveDobleFactor,
  loadingValidarClaveDobleFactor:
    state.transactionalReducer.loadingValidarClaveDobleFactor,
  claveDobleFactorUsuario: state.transactionalReducer.claveDobleFactorUsuario,
  bancosTransferencia: state.transferenciaReducer.bancosTransferencia,
  loadingBancosTransferencias:
    state.transferenciaReducer.loadingBancosTransferencias,
});

const TransferenciasCuentasIfisPage = ({
  cuentasOperaciones,
  loadingCuentasOperaciones,
  getCuentasOperaciones,
  currentUser,
  verificarDisponibilidadPago,
  loadingDisponibilidadPago,
  transferenciaCuentasIfisValidar,
  transferenciaCuentasIfisConfirmar,
  loadingTransferenciaCuentasIfisValidar,
  loadingTransferenciaCuentasIfisConfirmar,
  generarClaveDobleFactor,
  validarClaveDobleFactor,
  claveDobleFactorUsuario,
  loadingGenerarClaveDobleFactor,
  loadingValidarClaveDobleFactor,
  listarBancosTransferencia,
  bancosTransferencia,
  loadingBancosTransferencias,
}) => {
  //Constantes
  const generarClaveDobleFactorRequest = buildGenerarClaveDobleFactorRequest(
    CODIGO_TIPO_PROCESO_AUDITORIA_TRANSFERENCIAS_OTROS_BANCOS,
    claveDobleFactorUsuario
  );
  //effects
  useEffect(() => {
    if (currentUser?.username) {
      getCuentasOperaciones();
    }
  }, [getCuentasOperaciones, currentUser]);

  useEffect(() => {
    if (currentUser?.username) {
      listarBancosTransferencia();
    }
  }, [listarBancosTransferencia, currentUser]);

  //states
  const [
    faseTransferenciaCuentasIfis,
    setFaseTransferenciaCuentasIfis,
  ] = useState(FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_INICIAL);
  const [cuentaOrigen, setCuentaOrigen] = useState(null);
  const [codigoMonedaCuentaOrigen, setCodigoMonedaCuentaOrigen] = useState(
    null
  );
  // const [
  //   saldoDisponibleCuentaOrigen,
  //   setSaldoDisponibleCuentaOrigen,
  // ] = useState(null);
  const [codigoMoneda, setCodigoMoneda] = useState(null);
  const [bancoDestino, setBancoDestino] = useState(null);
  const [nombreBancoDestino, setNombreBancoDestino] = useState(null);
  const [tipoCuentaDestino, setTipoCuentaDestino] = useState(null);
  const [tipoCuentaOptions, setTipoCuentaOptions] = useState([]);
  const [cuentaDestino, setCuentaDestino] = useState(null);
  const [indicadorCuentaPropia, setIndicadorCuentaPropia] = useState(null);
  const [importeTransferencia, setImporteTransferencia] = useState(null);
  const [aplicaTipoCambio, setAplicaTipoCambio] = useState(false);
  const [importeValidado, setImporteValidado] = useState(null);
  const [comisionValidada, setComisionValidada] = useState(null);
  const [itfValidado, setItfValidado] = useState(null);
  const [tipoCambioValidado, setTipoCambioValidado] = useState(null);
  const [claveDobleFactor, setClaveDobleFactor] = useState(null);
  const [
    flagGeneracionExitosaClaveDobleFactor,
    setGeneracionExitosaClaveDobleFactor,
  ] = useState(false);
  const [
    msgValidacionClaveDobleFactor,
    setMsgValidacionClaveDobleFactor,
  ] = useState(null);
  const [
    openModalGenerarClaveDobleFactor,
    setOpenModalGenerarClaveDobleFactor,
  ] = useState(false);
  const [tipoDocumentoDestinatario, setTipoDocumentoDestinatario] = useState(
    null
  );
  const [
    numeroDocumentoDestinatario,
    setNumeroDocumentoDestinatario,
  ] = useState(null);
  const [
    apellidosNombresDestinatario,
    setApellidosNombresDestinatario,
  ] = useState(null);
  const [
    lengthNumeroDocumentoDestinatario,
    setLengthNumeroDocumentoDestinatario,
  ] = useState(null);
  const [importeDebitarValidado, setImporteDebitarValidado] = useState(null);
  const [monedaDebitarValidado, setMonedaDebitarValidado] = useState(null);
  //Options
  const cuentasOptions = createOptionsCuentaTransferencias(cuentasOperaciones);
  const bancosTransferenciaOptions = createOptionsBancosTransferencias(
    bancosTransferencia
  );

  //validates
  const validate = combineValidators({
    cuentaRetiro: composeValidators(
      isRequired({ message: "Debe seleccionar la cuenta origen" })
    )(),
    bancoDestino: composeValidators(
      isRequired({ message: "Debe seleccionar el banco destino" })
    )(),
    tipoCuentaDestino: composeValidators(
      isRequired({ message: "Debe seleccionar el tipo de cuenta destino" })
    )(),
    cuentaDeposito: composeValidators(
      isRequired(
        bancoDestino === CODIGO_BANCO_BCP ||
          bancoDestino === CODIGO_BANCO_SCOTIABANK
          ? { message: "Debe ingresar el número de cuenta destino" }
          : {
              message: "Debe ingresar el código de cuenta interbancario",
            }
      ),
      isCuentaDestinoDiferente(cuentaOrigen)({
        message: `La cuenta destino tiene que ser diferente a la cuenta origen`,
      }),
      hasLengthBetween(
        LONGITUD_MINIMA_CCI,
        LONGITUD_MAXIMA_CCI
      )({
        message: "Número de cuenta destino no válido",
      }),
      isCodigoCuentaInterbancarioValido(
        bancosTransferencia,
        bancoDestino
      )({
        message: `Número de cuenta no válido para el banco destino`,
      })
    )(),
    codigoMoneda: composeValidators(
      isRequired({ message: "Debe seleccionar la moneda" })
    )(),
    importe: composeValidators(
      isRequired({ message: "Importe es requerido" }),
      isGreaterThanOrEqual(1)({
        message: `El importe tiene que ser mayor a 0`,
      })
    )(),
    indicadorCuentaPropia: composeValidators(
      isRequired({ message: "Debe seleccionar el tipo de beneficiario" })
    )(),
    tipoDocumentoDestinatario: composeValidators(
      isRequiredIf(
        (values) =>
          values &&
          values.indicadorCuentaPropia ===
            INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_FALSE
      )({
        message: "Tipo de documento del destinatario es requerido.",
      })
    )(),
    numeroDocumentoDestinatario: composeValidators(
      isRequiredIf(
        (values) =>
          values &&
          values.indicadorCuentaPropia ===
            INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_FALSE
      )({
        message: "Número de documento del destinatario es requerido.",
      }),
      hasLengthBetween(
        lengthNumeroDocumentoDestinatario,
        lengthNumeroDocumentoDestinatario
      )({
        message: "Número de documento del destinatario no válido.",
      })
    )(),
    apellidosNombresDestinatario: composeValidators(
      isRequiredIf(
        (values) =>
          values &&
          values.indicadorCuentaPropia ===
            INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_FALSE
      )({
        message: "Apellidos y nombres del destinatario son requeridos.",
      }),
      hasLengthLessThan(LONGITUD_MAXIMA_APELLIDOS_NOMBRES_DESTINATARIO)({
        message: "Apellidos y nombres del destinatario no válido.",
      })
    )(),
  });
  //
  const validateConfirmacionTransferencia = combineValidators({
    claveDobleFactor: composeValidators(
      isRequired({ message: MESSAGE_VALIDACION_CLAVE_DOBLE_FACTOR }),
      hasLengthBetween(
        LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR,
        LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR
      )({
        message: MESSAGE_CLAVE_DOBLE_FACTOR_NO_VALIDA,
      })
    )(),
  });

  //business logic
  const onChangeTipoDocumentoDestinatario = (value) => {
    setTipoDocumentoDestinatario(value);
    //Actualizando longitud
    setLengthNumeroDocumentoDestinatario(
      getLengthNumeroDocumentoIdentidad(value)
    );
  };

  //Metodo que permite validar la transferencia
  const submitContinuar = async (values) => {
    //Verificando disponibilidad de pago
    const response = await verificarDisponibilidadPago();
    if (response && response.data && response.data.disponible === true) {
      const request = {
        cuentaRetiro: values.cuentaRetiro,
        importe: values.importe,
        codigoMoneda: values.codigoMoneda,
        banco: values.bancoDestino,
        tipoCuenta: values.tipoCuentaDestino,
        cuentaBancaria: values.cuentaDeposito,
        isACuentaTerceros:
          values.indicadorCuentaPropia !==
          INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_TRUE,
        tipoDocumentoIdentidad: values.tipoDocumentoDestinatario,
        numeroDocumentoIdentidad: values.numeroDocumentoDestinatario,
        nombreBeneficiario: values.apellidosNombresDestinatario,
      };
      const responseValidacion = await transferenciaCuentasIfisValidar(request);
      if (responseValidacion && responseValidacion.data) {
        try {
          //Generando clave doble factor
          const response = await generarClaveDobleFactor(
            generarClaveDobleFactorRequest
          );
          //end
          if (response && response.code === RESPONSE_MESSAGE_CODE_SUCCESS) {
            setImporteValidado(importeTransferencia);
            setItfValidado(responseValidacion.data.itf);
            setComisionValidada(responseValidacion.data.comisionBancaria);
            setTipoCambioValidado(responseValidacion.data.tipoCambio);
            setGeneracionExitosaClaveDobleFactor(true);
            //si las cuentas de origen es distinta al tipo de moneda a transferir aplica tipo de cambio
            setAplicaTipoCambio(codigoMonedaCuentaOrigen !== codigoMoneda);
            setMonedaDebitarValidado(
              responseValidacion.data.codigoMonedaRetiro
            );
            setImporteDebitarValidado(
              responseValidacion.data.importeRetiroTotal
            );
            //fase validacion
            setFaseTransferenciaCuentasIfis(
              FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_VALIDACION
            );
            resetScroll();
          }
        } catch (error) {
          if (error && error.data && error.data.status !== 401) {
            toast.error(error.data.message);
          }
        }
      }
    }
  };

  //Metodo que permite reiniciar algunos valores cuando se regresa en la transferencia
  const handleAtras = () => {
    setImporteValidado(null);
    setComisionValidada(null);
    setItfValidado(null);
    setTipoCambioValidado(null);
    setAplicaTipoCambio(false);
    setClaveDobleFactor(null);
    setGeneracionExitosaClaveDobleFactor(false);
    setMsgValidacionClaveDobleFactor(null);
    setMonedaDebitarValidado(null);
    setImporteDebitarValidado(null);
    //fase inicio
    setFaseTransferenciaCuentasIfis(
      FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_INICIAL
    );
  };

  const submitConfirmarTransferencia = async (values) => {
    //Validando Clave doble factor
    let responseValidacionClaveDobleFactor;
    try {
      responseValidacionClaveDobleFactor = await validarClaveDobleFactor(
        buildValidarClaveDobleFactorRequest(
          claveDobleFactorUsuario,
          claveDobleFactor
        )
      );
    } catch (error) {
      if (error && error.data && error.data.status !== 401) {
        const msgValidacion = error.data.message;
        setMsgValidacionClaveDobleFactor(msgValidacion);
        setGeneracionExitosaClaveDobleFactor(false);
        setOpenModalGenerarClaveDobleFactor(true);
        setClaveDobleFactor(null);
      }
    }
    //end
    if (
      responseValidacionClaveDobleFactor &&
      responseValidacionClaveDobleFactor.code === RESPONSE_MESSAGE_CODE_SUCCESS
    ) {
      //Enviando data para transaccion
      const request = {
        cuentaRetiro: cuentaOrigen,
        importe: importeTransferencia,
        codigoMoneda: codigoMoneda,
        banco: bancoDestino,
        tipoCuenta: tipoCuentaDestino,
        cuentaBancaria: cuentaDestino,
        isACuentaTerceros:
          indicadorCuentaPropia !==
          INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_TRUE,
        tipoDocumentoIdentidad: tipoDocumentoDestinatario,
        numeroDocumentoIdentidad: numeroDocumentoDestinatario,
        nombreBeneficiario: apellidosNombresDestinatario,
      };
      const responseConfirmacion = await transferenciaCuentasIfisConfirmar(
        request
      );
      if (
        responseConfirmacion &&
        responseConfirmacion.data &&
        responseConfirmacion.data.resultado === true
      ) {
        setFaseTransferenciaCuentasIfis(
          FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_PROCESADO
        );
        resetScroll();
      }
    }
  };

  //return
  if (loadingCuentasOperaciones)
    return <LoadingComponent content="Cargando cuentas..." />;
  if (loadingDisponibilidadPago)
    return <LoadingComponent content="Consultando disponibilidad de pago..." />;
  if (loadingTransferenciaCuentasIfisValidar)
    return <LoadingComponent content="Transferencia validar..." />;
  if (loadingTransferenciaCuentasIfisConfirmar)
    return <LoadingComponent content="Transferencia confirmar..." />;
  if (loadingGenerarClaveDobleFactor)
    return <LoadingComponent content="Generar Clave ..." />;
  if (loadingValidarClaveDobleFactor)
    return <LoadingComponent content="Validar Clave ..." />;
  if (loadingBancosTransferencias)
    return <LoadingComponent content="Bancos transferencias..." />;
  return (
    <>
      <Container className="containerPrincipal">
        {faseTransferenciaCuentasIfis ===
        FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_INICIAL ? (
          <>
            <TransferenciasCuentasIfisHeader />
            <FinalForm
              onSubmit={async (values) => {
                submitContinuar(values);
              }}
              initialValues={{
                cuentaRetiro: cuentaOrigen,
                bancoDestino: bancoDestino,
                tipoCuentaDestino: tipoCuentaDestino,
                cuentaDeposito: cuentaDestino,
                codigoMoneda: codigoMoneda,
                importe: importeTransferencia,
                indicadorCuentaPropia: indicadorCuentaPropia,
                tipoDocumentoDestinatario: tipoDocumentoDestinatario,
                numeroDocumentoDestinatario: numeroDocumentoDestinatario,
                apellidosNombresDestinatario: apellidosNombresDestinatario,
              }}
              validate={validate}
              render={({ handleSubmit, submitting, invalid, values }) => (
                <Form
                  onSubmit={handleSubmit}
                  error
                  style={{ marginTop: "2.5em" }}
                >
                  <Header
                    as="h4"
                    color="blue"
                    content="Selecciona la cuenta origen"
                  />
                  <Field
                    name="cuentaRetiro"
                    component={SelectedInput}
                    placeholder="Selecciona la cuenta origen"
                    options={cuentasOptions}
                    handleOnChange={(value) => {
                      setCuentaOrigen(value);
                      if (
                        value &&
                        cuentasOperaciones &&
                        cuentasOperaciones.length > 0
                      ) {
                        const cuenta = cuentasOperaciones.filter(
                          (c) => c.numeroCuenta === value
                        )[0];
                        // setSaldoDisponibleCuentaOrigen(cuenta.saldoDisponible);
                        setCodigoMonedaCuentaOrigen(cuenta.codigoMoneda);
                        setCodigoMoneda(cuenta.codigoMoneda);
                      }
                    }}
                  />
                  <Label color="blue" tag size="medium">
                    {MESSAGE_TRANSFERENCIA_CUENTA_ORIGEN}
                  </Label>
                  <Header
                    as="h4"
                    color="blue"
                    content="Selecciona el banco destino"
                  />
                  <Field
                    name="bancoDestino"
                    component={SelectedInput}
                    placeholder="Selecciona el banco destino"
                    options={bancosTransferenciaOptions}
                    handleOnChange={(value) => {
                      setBancoDestino(value);
                      setNombreBancoDestino(
                        bancosTransferencia.filter((b) => b.codigo === value)[0]
                          .nombre
                      );
                      setTipoCuentaDestino(null);
                      setTipoCuentaOptions(
                        createOptionsTipoCuentasPorBancoTransferencia(
                          bancosTransferencia.filter(
                            (b) => b.codigo === value
                          )[0]
                        )
                      );
                    }}
                  />
                  <Header
                    as="h4"
                    color="blue"
                    content="Selecciona el tipo de cuenta  destino"
                  />
                  <Field
                    name="tipoCuentaDestino"
                    component={SelectedInput}
                    placeholder="Selecciona el tipo de cuenta destino"
                    options={tipoCuentaOptions}
                    disabled={!bancoDestino}
                    handleOnChange={(value) => {
                      setTipoCuentaDestino(value);
                    }}
                  />
                  <Header
                    as="h4"
                    color="blue"
                    content="Número de cuenta destino:"
                  />
                  <Field
                    name="cuentaDeposito"
                    component={TextInput}
                    placeholder="Ingresa el número de cuenta destino:"
                    parse={normalizeNumero}
                    maxLength={LONGITUD_MAXIMA_CCI}
                    handleOnChange={(value) => {
                      setCuentaDestino(normalizeNumero(value));
                    }}
                    disabled={!bancoDestino}
                  />
                  <Label color="blue" tag size="medium">
                    {MESSAGE_NUMERO_CUENTA_BANCOS_IFIS}
                  </Label>
                  <Header as="h4" color="blue" content="Selecciona la moneda" />
                  <Field
                    name="codigoMoneda"
                    component={SelectedInput}
                    placeholder="Selecciona la moneda"
                    options={tipoMonedaOptions}
                    handleOnChange={(value) => {
                      setCodigoMoneda(value);
                    }}
                    disabled={true}
                  />
                  {codigoMonedaCuentaOrigen &&
                    codigoMoneda &&
                    codigoMonedaCuentaOrigen !== codigoMoneda && (
                      <Label color="blue" tag size="medium">
                        {TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL}
                      </Label>
                    )}
                  <Header as="h4" color="blue" content="Ingresa el importe" />
                  <Field
                    name="importe"
                    component={NumberInput}
                    placeholder="Ingresa el importe"
                    handleOnChange={(value) => {
                      setImporteTransferencia(Number(value));
                    }}
                    maxLength={LONGITUD_MAXIMA_IMPORTE}
                    disabled={!cuentaOrigen}
                  />
                  <Header
                    as="h4"
                    color="blue"
                    content="Datos del destinatario"
                  />
                  <Field
                    name="indicadorCuentaPropia"
                    component={RadioInput}
                    type="radio"
                    value={INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_TRUE}
                    handleOnChange={(value) => {
                      setIndicadorCuentaPropia(value);
                      //set datos cuenta propia
                      if (currentUser) {
                        setTipoDocumentoDestinatario(currentUser.tipoDocumento);
                        setLengthNumeroDocumentoDestinatario(
                          currentUser.numeroDocumento.length
                        );
                        setNumeroDocumentoDestinatario(
                          currentUser.numeroDocumento
                        );
                        setApellidosNombresDestinatario(
                          currentUser.nombreCompleto
                        );
                      }
                    }}
                    checked={
                      indicadorCuentaPropia ===
                      INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_TRUE
                    }
                    label="A cuenta propia"
                  />
                  <Field
                    name="indicadorCuentaPropia"
                    component={RadioInput}
                    type="radio"
                    value={"0"}
                    checked={indicadorCuentaPropia === "0"}
                    label="A cuenta de terceros"
                    handleOnChange={(value) => {
                      setIndicadorCuentaPropia(value);
                      //clean datos cuenta propia
                      setTipoDocumentoDestinatario(null);
                      setNumeroDocumentoDestinatario(null);
                      setApellidosNombresDestinatario(null);
                    }}
                  />
                  {indicadorCuentaPropia && (
                    <>
                      <Header
                        as="h4"
                        color="blue"
                        content="Tipo de documento"
                      />
                      <Field
                        name="tipoDocumentoDestinatario"
                        value={tipoDocumentoDestinatario}
                        component={SelectedInput}
                        placeholder="Tipo de documento destinatario"
                        options={tipoDocumentoOptions}
                        handleOnChange={onChangeTipoDocumentoDestinatario}
                        disabled={
                          indicadorCuentaPropia ===
                          INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_TRUE
                        }
                      />

                      <Header
                        as="h4"
                        color="blue"
                        content="Número de documento"
                      />
                      <Field
                        name="numeroDocumentoDestinatario"
                        value={numeroDocumentoDestinatario}
                        component={TextInput}
                        placeholder="Número de documento destinatario"
                        parse={(value) =>
                          normalizeNumeroDocumentoIdentidad(
                            value,
                            tipoDocumentoDestinatario
                          )
                        }
                        maxLength={lengthNumeroDocumentoDestinatario}
                        handleOnChange={(value) => {
                          setNumeroDocumentoDestinatario(
                            normalizeNumeroDocumentoIdentidad(
                              value,
                              tipoDocumentoDestinatario
                            )
                          );
                        }}
                        disabled={
                          !tipoDocumentoDestinatario ||
                          indicadorCuentaPropia ===
                            INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_TRUE
                        }
                      />

                      <Header
                        as="h4"
                        color="blue"
                        content="Apellidos y Nombres"
                      />
                      <Field
                        name="apellidosNombresDestinatario"
                        component={TextInput}
                        value={apellidosNombresDestinatario}
                        placeholder="Apellidos y Nombres destinatario"
                        parse={(value) =>
                          normalizeLetrasEspacios(value).toUpperCase()
                        }
                        maxLength={
                          LONGITUD_MAXIMA_APELLIDOS_NOMBRES_DESTINATARIO
                        }
                        handleOnChange={(value) => {
                          setApellidosNombresDestinatario(
                            normalizeLetrasEspacios(value).toUpperCase()
                          );
                        }}
                        disabled={
                          indicadorCuentaPropia ===
                          INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_TRUE
                        }
                      />
                    </>
                  )}
                  {/* <div>{JSON.stringify(values)}</div> */}
                  <Container textAlign="center">
                    <Button
                      content="Continuar"
                      disabled={invalid}
                      loading={submitting}
                      style={{ minWidth: "12em", maxWidth: "15em" }}
                      color="yellow"
                      size="large"
                    />
                  </Container>
                </Form>
              )}
            />
          </>
        ) : faseTransferenciaCuentasIfis ===
          FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_VALIDACION ? (
          <>
            <TransferenciasCuentasIfisHeader />
            <DisponibilidadOperacionesMessage />
            <Header
              as="h4"
              color="blue"
              content="Revisa los datos y confirma la transferencia"
            />
            <TransferenciasCuentasIfisResumen
              cuentaOrigen={cuentaOrigen}
              bancoDestino={nombreBancoDestino}
              cuentaDestino={cuentaDestino}
              aplicaTipoCambio={aplicaTipoCambio}
              tipoCambio={tipoCambioValidado}
              itfTransferencia={itfValidado}
              comisionTransferencia={comisionValidada}
              codigoMonedaTransferencia={codigoMoneda}
              importeTotalTransferir={importeTransferencia}
              importeValidado={importeValidado}
              tipoDocumentoDestino={tipoDocumentoDestinatario}
              numeroDocumentoDestino={numeroDocumentoDestinatario}
              nombreTitularDestino={apellidosNombresDestinatario}
              importeDebitarValidado={importeDebitarValidado}
              monedaDebitarValidado={monedaDebitarValidado}
            />
            <br />
            <FinalForm
              onSubmit={async (values) => {
                submitConfirmarTransferencia(values);
              }}
              initialValues={{
                claveDobleFactor: claveDobleFactor,
              }}
              validate={validateConfirmacionTransferencia}
              render={({ handleSubmit, invalid }) => (
                <Form onSubmit={handleSubmit} error>
                  <Header
                    as="h4"
                    color="blue"
                    content={LABEL_CONFIRMAR_OPERACION_CLAVE_DOBLE_FACTOR}
                    textAlign="left"
                  />
                  <Field
                    name="claveDobleFactor"
                    component={TextInput}
                    placeholder={LABEL_INGRESE_CLAVE_DOBLE_FACTOR}
                    maxLength={LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR}
                    parse={normalizeNumero}
                    handleOnChange={(value) => {
                      setClaveDobleFactor(normalizeNumero(value));
                    }}
                  />
                  <br />
                  <Grid>
                    <Grid.Row>
                      <Grid.Column
                        computer={4}
                        largeScreen={4}
                        mobile={7}
                        tablet={6}
                      >
                        <Button
                          fluid
                          content="Atrás"
                          color="blue"
                          size="large"
                          onClick={(e) => {
                            e.preventDefault();
                            handleAtras();
                          }}
                        />
                      </Grid.Column>
                      <Grid.Column
                        computer={8}
                        largeScreen={8}
                        mobile={2}
                        tablet={4}
                      />
                      <Grid.Column
                        computer={4}
                        largeScreen={4}
                        mobile={7}
                        tablet={6}
                      >
                        <Button
                          content="Confirmar"
                          disabled={
                            invalid && flagGeneracionExitosaClaveDobleFactor
                          }
                          fluid
                          color="yellow"
                          size="large"
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Form>
              )}
            />
          </>
        ) : (
          <>
            <Container style={{ width: "65%" }} textAlign="center">
              <br />
              <Icon name="check circle outline" color="yellow" size="huge" />
              <Header as="h1" color="blue" size="huge">
                Se realizó exitosamente tu transferencia
              </Header>
              <Header as="h4" color="blue" size="tiny">
                Te enviamos un correo con el detalle de la transferencia.
              </Header>
              <TransferenciasCuentasIfisResumen
                cuentaOrigen={cuentaOrigen}
                bancoDestino={nombreBancoDestino}
                cuentaDestino={cuentaDestino}
                aplicaTipoCambio={aplicaTipoCambio}
                tipoCambio={tipoCambioValidado}
                comisionTransferencia={comisionValidada}
                itfTransferencia={itfValidado}
                codigoMonedaTransferencia={codigoMoneda}
                importeTotalTransferir={importeTransferencia}
                importeValidado={importeValidado}
                transferenciaExitosa={true}
                tipoDocumentoDestino={tipoDocumentoDestinatario}
                numeroDocumentoDestino={numeroDocumentoDestinatario}
                nombreTitularDestino={apellidosNombresDestinatario}
                importeDebitarValidado={importeDebitarValidado}
                monedaDebitarValidado={monedaDebitarValidado}
              />
              <br />
              <Grid stackable>
                <Grid.Row>
                  <Grid.Column
                    computer={8}
                    largeScreen={8}
                    mobile={8}
                    tablet={8}
                  >
                    <Button
                      as={Link}
                      to="/transferencias"
                      color="blue"
                      fluid
                      size="large"
                      content="Nueva transferencia"
                    />
                  </Grid.Column>
                  <Grid.Column
                    computer={8}
                    largeScreen={8}
                    mobile={8}
                    tablet={8}
                    textAlign="right"
                  >
                    <Button
                      to="/cuentas"
                      as={Link}
                      color="yellow"
                      size="large"
                      fluid
                      content="Ir a mis cuentas"
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </>
        )}
      </Container>
      <ModalClaveDobleFactor
        openModel={openModalGenerarClaveDobleFactor}
        generarClaveDobleFactorRequest={generarClaveDobleFactorRequest}
        msgValidacionClaveDobleFactor={msgValidacionClaveDobleFactor}
        setGeneracionExitosaClaveDobleFactor={
          setGeneracionExitosaClaveDobleFactor
        }
        setOpenModalGenerarClaveDobleFactor={
          setOpenModalGenerarClaveDobleFactor
        }
      />
    </>
  );
};
TransferenciasCuentasIfisPage.propTypes = {
  cuentasOperaciones: PropTypes.array.isRequired,
  loadingCuentasOperaciones: PropTypes.bool.isRequired,
  getCuentasOperaciones: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  verificarDisponibilidadPago: PropTypes.func.isRequired,
  loadingDisponibilidadPago: PropTypes.bool.isRequired,
  transferenciaCuentasIfisValidar: PropTypes.func.isRequired,
  transferenciaCuentasIfisConfirmar: PropTypes.func.isRequired,
  loadingTransferenciaCuentasIfisValidar: PropTypes.bool.isRequired,
  loadingTransferenciaCuentasIfisConfirmar: PropTypes.bool.isRequired,
  generarClaveDobleFactor: PropTypes.func.isRequired,
  validarClaveDobleFactor: PropTypes.func.isRequired,
  loadingGenerarClaveDobleFactor: PropTypes.bool.isRequired,
  loadingValidarClaveDobleFactor: PropTypes.bool.isRequired,
  listarBancosTransferencia: PropTypes.func.isRequired,
  loadingBancosTransferencias: PropTypes.bool.isRequired,
  bancosTransferencia: PropTypes.array.isRequired,
};
export default connect(mapState, actions)(TransferenciasCuentasIfisPage);
